"use strict";
var AirlineViewModel = (function () {
    function AirlineViewModel() {
        this.providerCode = '';
        this.name = '';
    }
    return AirlineViewModel;
}());
exports.AirlineViewModel = AirlineViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/airline-view.model.js